export default {"src":"/_next/static/media/404.2070afec.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};